'use strict';

module.exports = ValidationError;


function ValidationError(errors) {
  this.message = 'validation failed';
  this.errors = errors;
  this.ajv = this.validation = true;
}


ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;



//////////////////
// WEBPACK FOOTER
// ../~/ajv/lib/compile/validation_error.js
// module id = 613
// module chunks = 0